import request, { formatRequest } from "@/utils/request"

import { ApiListResult, ApiResult } from "../types"
import {
  ProductAttributes,
  ReasonGroupDetail,
  ReturnRuleSimpleProps,
  RuleForm,
  SaveReasonGroupParams,
} from "./type"
export interface AddressItem {
  name: string
  address: string
  address_detail: string
  city: string
  zip: string
  province: string
  country: string
  is_default: number
  id: number
  show_popover?: boolean
  country_code: string
  phone: string
  full_address: string
}

export interface PackageItem {
  distance_unit: string
  height: string
  id: string
  length: string
  mass_unit: string
  name: string
  weight: string
  width: string
  is_default?: any
}

export type ReasonGroupRules = {
  product_type: string[]
  collection: string[]
  tag: string[]
}

export type reasonGroupType = {
  id: number // 原因组ID
  type: number // 0默认,1用户创建
  name: string // 原因组名称
  reason_count: number // 该组下的 reason 数量
  rules: ReasonGroupRules // 匹配规则
  show_popover?: boolean
}
export type reasonType = {
  id: number // 原因ID
  content: string // 原因文本
  description_is_required: number // 描述是否必填 0没有选项 1是 2否
  image_proof_is_required: number // 图片证明是否必填 0没有选项 1是 2否
  reason_note: string // 原因备注（翻译模式）
  comment_placeholder: string // 评论框占位（翻译模式）
  proof_helper: string // 凭证上传提示（翻译模式）
  sort_no?: number // 排序（新列表接口不返回）
  show_popover?: boolean
}

export type GetReasonParams = {
  code?: string
}

export type Reason = {
  id?: number
  content: string
  // 0 关闭 / 1 必填 / 2 选填 —— Customer comment
  description_is_required: number
  // 0 关闭 / 1 必填 / 2 选填 —— Proof
  image_proof_is_required: number
  reason_note: string
  comment_placeholder: string
  proof_helper: string
}

// 创建 Reason 入参（v6.2）
export type CreateReasonParams = Omit<Reason, "id"> & {
  code: string
}

// 更新 Reason 入参（v6.2）
export type UpdateReasonParams = Reason & {
  id: number
}

// 批量更新 Reason 翻译 单条（v6.2）
export type BatchUpdateReasonItem = {
  id: number
  content: string
  reason_note: string
  comment_placeholder: string
  proof_helper: string
}

// 批量更新 Reason 翻译 入参（v6.2）
export type BatchUpdateReasonParams = {
  code: string
  reasons: BatchUpdateReasonItem[]
}

export type saveOrderWidgetType = {
  language: string
  title: string
  description: string
  button: string
  add_widget_url?: string
}

export type savePackingSlipProps = {
  id: number
  shop_id?: number
  ship_from_countries: string[]
  shipping_method_ids: number[]
  store_name: string
  packing_slip_name: string
  reason_for_export: string
  note: string
  taxes_and_duties: string
  support_email: string
}

export type PackingSlipUrlProps = {
  request_id: number
  packing_slip_id: number
}

export type searchMapByAddressProps = {
  search: string
  country: string
}

export type searchMapByAddressDetailProps = {
  place_id: string
}

export type IspecificCollections = {
  name: string
  code: string
}

export type IExchangeConfigCom = {
  id: number
  open: boolean
  sort: number
  name: string
  list?: IspecificCollections[]
}

export type IExchangeConfig = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
  shopify_recommend: IExchangeConfigCom
  all_product: IExchangeConfigCom
  specific_collections: IExchangeConfigCom
}

export type IBlockRuleRule = {
  rule_type: number
  rule_com: number
  rule_value: number
}

export type IBlockRule = {
  id: number
  name: string
  reason: string
  rule: {
    logical: number
    list: IBlockRuleRule[]
  }
}

/** 集成状态 */
export enum statusEnum {
  /** 关闭 */
  Disabled = 0,
  /** 开启 */
  Active = 1,
}

export type IntegrationListItem = {
  id: number
  config_id: number
  sort: number
  name: string
  status: statusEnum
  url: string
  router: string
  image: string
  region: string
  region_list: string[]
  badge: string[]
  official_address: string
  /** 配置信息（不同集成会有不同参数） */
  data: Record<string, any>
}

export type IntegrationListResponse = IntegrationListItem[]

export type LogisticsPartnerItem = {
  /** id > 0 为间接集成，否则为直接集成 */
  code: string
  config_id: number
  direct_id: number
  direct_type: number
  id: number
  is_used: boolean
  name: string
  show_name: string
  status: number
  data?: Record<string, any>
}

export type DHLLocationItem = {
  receiverId: string
  shipperCountry: string
  receiverAddress: {
    name1: string
    name2: string
    name3: string
    addressStreet: string
    addressHouse: string
    city: string
    postalCode: string
  }
}

export type DHLLocationResponse = DHLLocationItem[]

const APISetting = {
  // 关闭B端setting模块集成功能提示框
  closeBanner() {
    return request.get("/v1/close")
  },

  getAllAddress(params: object) {
    return formatRequest(
      request.get<ApiListResult<AddressItem>>("/v1/returnAddress", { params }),
    )
  },
  getAllPackage(data) {
    return formatRequest(
      request.post<ApiListResult<PackageItem>>(
        "/go-api/v1/setting/packageList",
        data,
      ),
    )
  },
  addPackage(data: Omit<PackageItem, "id">) {
    return formatRequest(request.post("/go-api/v1/setting/addPackage", data), {
      success: {
        1000: t("AddedSuccessfully"),
      },
    })
  },
  editPackage(data: PackageItem) {
    return formatRequest(
      request.post("/go-api/v1/setting/updatePackage", data),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },

  delAddress(params: object) {
    return formatRequest(request.post("/v1/delReturnAddress", params), {
      success: {
        1000: t("DeletedSuccessfully"),
      },
    })
  },

  delPackage(params: object) {
    return formatRequest(
      request.post("/go-api/v1/setting/delPackage", params),
      {
        success: {
          1000: t("DeletedSuccessfully"),
        },
      },
    )
  },

  defaultAddress(params: object) {
    return formatRequest(request.post("v1/setDefaultAddress", params), {
      success: {
        1000: t("SavedSuccessfully"),
      },
      error: {
        "*": t("SavedFailed"),
      },
    })
  },

  defaultPackage(params) {
    return formatRequest(
      request.post("/go-api/v1/setting/setPackageAsDefault", params),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },

  getShopifyAddress() {
    return request.get("/v1/returnAddress")
  },
  getShopifyAddressNew() {
    return formatRequest(request.get("/v1/returnAddress"))
  },

  saveShopifyAddress(params: object) {
    return formatRequest(request.post("/v1/returnAddress", params), {
      hideMsg: true,
      success: {
        1000: t("AddedSuccessfully"),
      },
    })
  },
  editShopifyAddress(params) {
    return formatRequest(
      request.put(`/v1/returnAddress/${params.id}`, params),
      {
        hideMsg: true,
        success: {
          1000: t("AddressUpdatedSuccessfully"),
        },
      },
    )
  },
  saveRule(params) {
    return formatRequest(request.post("/go-api/v1/setting/setRule", params), {
      hideMsg: true, // api报错不展示toast提示语
      success: {
        1000: t("SavedSuccessfully"),
      },
      error: {
        "*": t("SavedFailed"),
      },
    })
  },
  saveMethod(params: object, code: string) {
    return formatRequest(
      request.put("/v1/updateShippingMethod", {
        param: params,
        code,
      }),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  saveReason(params: object) {
    return request.post("/v1/reason", params)
  },
  editReason(params: any) {
    return request.put(`/v1/reason/${params.id}`, params)
  },
  // 创建 Reason（v6.2）
  createReason(params: CreateReasonParams) {
    return formatRequest(
      request.post("/go-api/v1/setting/reason/create", params),
      {
        hideMsg: true, // 由调用方根据 code 处理提示
      },
    )
  },
  // 更新 Reason（v6.2）
  updateReason(params: UpdateReasonParams) {
    return formatRequest(
      request.post("/go-api/v1/setting/reason/update", params),
      {
        hideMsg: true, // 由调用方根据 code 处理提示
      },
    )
  },
  // Reason 详情（v6.2）
  getReasonDetailV2(id: string | number) {
    return formatRequest(
      request.get<ApiResult<Reason>>("/go-api/v1/setting/reason/detail", {
        params: { id },
      }),
    )
  },
  // 获取 Reason 所在 Group 数量（v6.2）
  getReasonInGroupCount(id: number) {
    return formatRequest(
      request.get<ApiResult<{ count: number }>>(
        "/go-api/v1/setting/reason/inReasonGroup",
        { params: { id } },
      ),
    )
  },
  // 删除 Reason（v6.2）
  delReasonV2(id: number) {
    return formatRequest(
      request.post("/go-api/v1/setting/reason/delete", { id }),
      {
        success: {
          1000: t("DeletedSuccessfully"),
        },
      },
    )
  },
  // 批量更新 Reason 翻译（v6.2）
  batchUpdateReason(params: BatchUpdateReasonParams) {
    return formatRequest(
      request.post("/go-api/v1/setting/reason/batchUpdate", params),
      {
        hideMsg: true, // 由调用方根据 code 处理提示
      },
    )
  },
  delReason(params) {
    return formatRequest(request.post("/v1/delReason", params), {
      success: {
        1000: t("DeletedSuccessfully"),
      },
    })
  },
  delReasonGroup(params) {
    return formatRequest(request.post("/v1/delReasonGroup", params), {
      success: {
        1000: t("DeletedSuccessfully"),
      },
    })
  },
  saveReasonGroup(params: object) {
    return request.post("/v1/reasonGroup", params)
  },
  editReasonGroup(params) {
    return request.put(`/v1/reasonGroup/${params.id}`, params)
  },
  getReasonGroupDetail(id) {
    return request.get(`/v1/reasonGroup/${id}`)
  },
  // Reason Group 详情（新）
  getReasonGroupDetailNew(id: string | number) {
    return formatRequest(
      request.get<ApiResult<ReasonGroupDetail>>(
        "/go-api/v1/setting/reasonGroup/detail",
        { params: { id } },
      ),
    )
  },
  // 创建 Reason Group（新）
  createReasonGroup(params: SaveReasonGroupParams) {
    return formatRequest(
      request.post("/go-api/v1/setting/reasonGroup/create", params),
      {
        hideMsg: true, // 由调用方根据 code 处理错误提示
      },
    )
  },
  // 更新 Reason Group（新）
  updateReasonGroup(params: SaveReasonGroupParams) {
    return formatRequest(
      request.post("/go-api/v1/setting/reasonGroup/update", params),
      {
        hideMsg: true, // 由调用方根据 code 处理错误提示
      },
    )
  },
  // Reason Group 排序
  sortReasonGroup(ids: number[]) {
    return formatRequest(
      request.post("/go-api/v1/setting/reasonGroup/sort", { ids }),
      { hideMsg: true },
    )
  },
  // 产品属性列表（商品类型 / 系列 / 标签）
  getProductAttributes(reason_group_id?: string | number) {
    return formatRequest(
      request.get<ApiResult<ProductAttributes>>(
        "/go-api/v1/setting/productAttributes",
        { params: { reason_group_id } },
      ),
    )
  },
  saveIntegra(params: object) {
    return formatRequest(
      request.post("/v1/updateLogisticsIntegration", params),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
      },
    )
  },
  logisticsIntegrationSwitch(params) {
    return formatRequest(
      request.post("/v1/logisticsIntegrationSwitch", params),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },

  getShopifyCountry(params: object) {
    return request.post("/go-api/v1/addr/getRegion", params)
  },
  getRule() {
    return formatRequest(request.get("/go-api/v1/setting/getRule"))
  },
  getMethod(code) {
    return formatRequest(request.get(`/v1/returnShippingMethod?code=${code}`))
  },
  getReasonGroup() {
    return formatRequest(
      request.get<ApiResult<reasonGroupType[]>>(
        "/go-api/v1/setting/reasonGroups",
      ),
    )
  },
  getReasonNew(params?: GetReasonParams) {
    return formatRequest(
      request.get<ApiResult<reasonType[]>>("/go-api/v1/setting/reasons", {
        params,
      }),
    )
  },
  getReason(params?: GetReasonParams) {
    return formatRequest(
      request.get<ApiResult<reasonType[]>>("/go-api/v1/setting/reasons", {
        params,
      }),
    )
  },
  getReasonDetail(id, code) {
    return request.get<ApiResult<Reason>>(`/v1/reason/${id}?code=${code}`)
  },
  // 间接集成列表 修改go列表
  getIntegrationList(params?: { is_workflow?: boolean }) {
    return formatRequest(
      request.get<ApiResult<IntegrationListResponse>>(
        "/go-api/v1/integration/indirect/list",
        { params },
      ),
    )
  },
  getDHLLocation() {
    return formatRequest(
      request.get<ApiResult<DHLLocationResponse>>(
        "/go-api/v1/integration/GetLocationListByDhl",
      ),
    )
  },
  getActiveLogistics() {
    return request.get("/v1/logisticsPartner")
  },
  getIntegrationListNew(
    params: {
      request_id: number
      type: number | undefined
    },
    scenario?: string,
  ) {
    if (scenario) {
      return formatRequest(
        request.get<ApiResult<LogisticsPartnerItem[]>>(
          "/go-api/v1/management/sandbox/logisticsPartnerList",
        ),
      )
    }

    return formatRequest(
      request.post<ApiResult<LogisticsPartnerItem[]>>(
        "/v1/logisticsPartnerList",
        params,
      ),
    )
  },

  getIntegrationInfo(params: object) {
    return request.post("/v1/logisticsIntegrationInfo", params)
  },
  /**
   * 获取ShipStation 运输商
   */
  getCarrierByShipStation(params: { type: number }) {
    return formatRequest(
      request.get("/v1/getCarriersByShipstation", { params }),
    )
  },

  /**
   * 获取服务配置
   */
  getShipStationService(params) {
    return formatRequest(
      request.get("/v1/getServicesByShipstation", { params }),
    )
  },

  /**
   * 获取包装配置
   */
  getShipStationPackage(params) {
    return formatRequest(
      request.get("/v1/getPackagesByShipstation", { params }),
    )
  },

  getProductType() {
    return request.get("/v1/getProductTypes")
  },

  getReturnFeeConfig() {
    return formatRequest(request.get("/go-api/v1/setting/getReturnFee"))
  },

  getReturnFeeConfigByV2(code: string) {
    return formatRequest(
      request.get(`/go-api/v2/setting/getReturnSolution?code=${code}`),
    )
  },

  getSolutionsAndReason(params) {
    return formatRequest(
      request.get("/go-api/v1/setting/getReturnFeeConfig", { params }),
    )
  },

  // 设置return rewards
  setReturnRewards(params) {
    return formatRequest(
      request.post("/go-api/v1/setting/setReturnRewards", params),
      {
        hideMsg: true, // api报错不展示toast提示语
      },
    )
  },

  // 获取return rewards
  getReturnRewards() {
    return formatRequest(request.get("/go-api/v1/setting/getReturnRewards"))
  },

  /**
   * 获取假门配置
   */
  getAutoConfig() {
    return formatRequest(request.get("/go-api/v1/auto/get"))
  },

  /**
   * 投票
   */
  voteAutomation(params) {
    return formatRequest(request.post("/go-api/v1/auto/set", params), {
      error: {
        "*": t("SavedFailed"),
      },
    })
  },

  /**
   * 更新原因组
   */
  updateAllReturn(params) {
    return formatRequest(request.post("/v1/updateReasonByBatch", params), {
      hideMsg: true, // api报错不展示toast提示语
    })
  },

  updateReturnFeeConfig(params) {
    return formatRequest(
      request.post("/go-api/v2/setting/setReturnFee", params),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },

  setReturnSolution(params) {
    return formatRequest(
      request.post("/go-api/v2/setting/setReturnSolution", params),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },

  updateReturnFeeConfigByV2(params) {
    return formatRequest(
      request.post("/go-api/v2/setting/setReturnSolution", params),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },

  updateTestMode(params) {
    return formatRequest(request.post("/v1/directIntegrations", params), {
      success: {
        1000: t("SavedSuccessfully"),
      },
      error: {
        "*": t("SavedFailed"),
      },
    })
  },

  /**
   * @description 获取oss直传密钥等参数
   */
  getUploadKey() {
    return request.get("/v1/getUploadKey")
  },

  /**
   * 获取补货地址
   */
  getLocation() {
    return request.get("/v1/location")
  },
  /**
   * 获取补货地址
   */
  getLocationList(params: any, scenario?: string) {
    const requestUrl = scenario
      ? "/go-api/v1/management/sandbox/locationList"
      : "/v1/getLocationList"
    const requestData = scenario ? { scenario, ...params } : params
    return formatRequest(request.get(requestUrl, { params: requestData }), {
      hideMsg: true,
    })
  },
  getBlockList(params) {
    return formatRequest(
      request.post<ApiResult<BlockListData>>("/go-api/v1/block/list", params),
    )
  },
  getBlockTypeData(params) {
    return formatRequest(
      request.post<ApiResult<ProductTypeData>>(
        "/go-api/v1/block/before",
        params,
      ),
    )
  },
  getDiscountedTypeData(params) {
    return formatRequest(
      request.get<ApiResult<{ label: string; value: string }[]>>(
        "/go-api/v1/block/beforeDiscount",
        params,
      ),
    )
  },
  getEmailData(params) {
    return formatRequest(
      request.post<ApiResult<ProductTypeData>>("/v1/block/email", params),
    )
  },
  getRiskOrderData(params) {
    return formatRequest(
      request.get<ApiResult<{ label: string; value: string }[]>>(
        "/go-api/v1/block/beforeRisk",
        params,
      ),
    )
  },
  getProductSKUData(params) {
    return formatRequest(
      request.post<ApiResult<ProductTypeData>>("/v1/block/productSku", params),
    )
  },
  addBlock(params: OperateBlockParams) {
    return formatRequest(
      request.post<ApiResult<ProductTypeData>>("/go-api/v1/block/set", params),
      {
        success: {
          1000: t("AddedSuccessfully"),
        },
      },
    )
  },
  deleteBlock(params: OperateBlockParams) {
    return formatRequest(
      request.post<ApiResult<ProductTypeData>>("/go-api/v1/block/del", params),
      {
        success: {
          1000: t("DeletedSuccessfully"),
        },
      },
    )
  },
  getPackageList(params) {
    return formatRequest(
      request.post("/go-api/v1/setting/packageList", params),
      {
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  getAllPackageList(scenario?: string) {
    if (scenario) {
      return formatRequest(
        request.get("/go-api/v1/management/sandbox/packageSize"),
      )
    }

    return formatRequest(request.get("/go-api/v1/setting/GetAllList"), {
      error: {
        "*": t("SavedFailed"),
      },
    })
  },
  getAllAddressList(scenario?: string) {
    if (scenario) {
      return formatRequest(
        request.get("/go-api/v1/management/sandbox/addressList"),
      )
    }

    return formatRequest(request.get("/v1/getAddressList"), {
      error: {
        "*": t("SavedFailed"),
      },
    })
  },
  // 获取直接集成列表 换成go接口
  getDirectIntegrationList(params: { is_workflow: boolean }) {
    return formatRequest(
      request.get("/go-api/v1/integration/direct/list", { params }),
    )
  },

  getDirectIntegrationDetail(data: { code: string }) {
    return formatRequest(
      request.post(`/go-api/v1/integration/direct/other/config`, data),
    )
  },

  saveDirectIntegration(data: {
    code: string
    eori?: string
    vat_number?: string
  }) {
    return formatRequest(
      request.post("/go-api/v1/integration/direct/other/save", data),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },

  // 指定美元金额转换为店铺货币
  getExchangeShopCurrency(params: object) {
    return formatRequest(
      request.get("/go-api/v1/com/shopCurrency/exchange", { params }),
      {
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  // 获取小部件设置详情数据
  getWidgetDetail() {
    return formatRequest(
      request.get("/go-api/v1/setting/shop/order_widget/info"),
      {
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  // 保存小部件设置
  saveOrderWidget(params: saveOrderWidgetType) {
    return formatRequest(
      request.post("/go-api/v1/setting/order_widget/save", params),
      {
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  // 获取装箱单列表
  getPackingSlipList() {
    return formatRequest(request.get("/go-api/v1/setting/packingSlip/list"), {
      error: {
        "*": t("SavedFailed"),
      },
    })
  },
  // 获取装箱单信息
  getPackingSlipConfig(id: number) {
    return formatRequest(
      request.post("/go-api/v1/setting/packingSlip/config", { id }),
      {
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  // 装箱单信息保存
  savePackingSlip(params: savePackingSlipProps) {
    return formatRequest(
      request.post("/go-api/v1/setting/packingSlip/save", params),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  // 装箱单信息保存开关
  savePackingSlipSwitch(is_packing_slip: number) {
    return formatRequest(
      request.post("/go-api/v1/setting/packingSlip/switch", {
        is_packing_slip,
      }),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  // 获取装箱单模板接口
  getPackingSlipUrl(params: PackingSlipUrlProps) {
    return formatRequest(request.post("/v1/create/packingSlip", params), {
      error: {
        "*": t("SavedFailed"),
      },
    })
  },

  // 补充地址信息 搜索列表 Seach
  getSearchMapByAddressList(params: searchMapByAddressProps) {
    return formatRequest(request.post("/go-api/v1/com/map/search", params))
  },
  // 补充地址信息详情detail
  getSearchMapByAddressDetail(params: searchMapByAddressDetailProps) {
    return formatRequest(request.post("/go-api/v1/com/map/detail", params))
  },
  // 获取换其他货推荐配置
  getExchangeConfig() {
    return formatRequest(request.get("/go-api/v1/setting/getExchangeConfig"), {
      error: {
        "*": t("SavedFailed"),
      },
    })
  },
  // 更新换其他货推荐配置
  setExchangeConfig(params: IExchangeConfig[]) {
    return formatRequest(
      request.post("/go-api/v1/setting/setExchangeConfig", params),
    )
  },
  // 获取 BlockRule 配置
  getBlockRule(params: { id: number; type: number }) {
    return formatRequest<RuleForm>(
      request.post("/go-api/v1/block/getBlockRule", params),
    )
  },
  // 保存 BlockRule 配置
  saveBlockRule(params: RuleForm) {
    return formatRequest(
      request.post("/go-api/v1/block/saveBlockRule", params),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          2001: t("TheNameMustBeUnique"),
          "*": t("SavedFailed"),
        },
      },
    )
  },
  // 删除 BlockRule 配置
  delBlockRule(params: { ids: number[] }) {
    return formatRequest(
      request.post("/go-api/v1/block/delBlockRule", params),
      {
        success: {
          1000: t("DeletedSuccessfully"),
        },
      },
    )
  },
  // 图片上传原因 详情
  getImageUpdateReasonDetail(code: string) {
    return formatRequest(
      request.get("/go-api/v1/setting/reasonOther/list", {
        params: { code },
      }),
      {
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  // 保存图片上传 配置
  saveImageUpdateReason(params: { code: string; proof_description: string }) {
    return formatRequest(
      request.post("/go-api/v1/setting/reasonOther/save", params),
      {
        hideMsg: true, // api报错不展示toast提示语
      },
    )
  },
  // 获取return rewards\shipping fee\return fee设置
  getReturnRuleSimple() {
    return formatRequest<ReturnRuleSimpleProps>(
      request.get("/go-api/v1/setting/getReturnRuleSimple"),
    )
  },
  // return rewards\shipping fee\return fee保存
  setReturnRuleSimple(params: ReturnRuleSimpleProps) {
    return formatRequest(
      request.post("/go-api/v1/setting/setReturnRuleSimple", params),
      {
        hideMsg: true, // api报错不展示toast提示语
      },
    )
  },
  updateSenderName(data: { sender_name: string }) {
    return formatRequest(request.post("/go-api/shop/update_sender_name", data))
  },
  sendEmailCode(data) {
    return formatRequest(request.post("/go-api/shop/send_email_code", data))
  },
  verifyEmailCode(data) {
    return formatRequest(request.post("/go-api/shop/verify_email_code", data), {
      hideMsg: true,
    })
  },
  submitEmailDomain(data) {
    return formatRequest(request.post("/go-api/shop/submit_email_domain", data))
  },
  verifyEmailDomain() {
    return formatRequest(request.post("/go-api/shop/verify_email_domain"))
  },
  getNotifySender() {
    return formatRequest(request.get("/go-api/shop/notify_sender"))
  },
}

export interface BlockListData {
  Counts: {
    [key in BlockListTypeEnum]: number
  }
  current_page: number
  Data: BlockListDataItem[]
  last_page: number
  per_page: number
  total: number
}

export interface BlockListDataItem {
  name: string
  time: number
  value: string
  order_url: string
}

export interface AddBlockParamsItem {
  value: string
  name: string
}

export interface OperateBlockParams {
  type: BlockListTypeEnum
  value: AddBlockParamsItem[] | string[]
  // 0: 追加 1: 覆盖
  up_type?: number
}

export interface ProductTypeData {
  current_page: number
  Data: AddBlockItem[]
  first_page_url: string
  from: number
  last_page: number
  last_page_url: string
  links: Link[]
  next_page_url: null
  path: string
  per_page: number
  prev_page_url: null
  to: number
  total: number
}

export interface AddBlockItem {
  name?: string
  label: string
  value: string
}

export interface Link {
  active: boolean
  label: string
  url: null | string
}

export enum BlockListTypeEnum {
  name = "block_product_name",
  discount = "block_order_discount_type",
  product = "block_product_type",
  sku = "block_product_sku",
  email = "block_order_email",
  risk = "block_order_risk",
  rules = "block_rules",
  collection = "block_collection",
  country = "block_country",
}

export interface BlockListQuery {
  type: BlockListTypeEnum
  search: string
  current_page: number
  limit: number
}
export default APISetting
